"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _core = require("@material-ui/core");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Footer = function Footer(_ref) {
  var classes = _ref.classes,
      version = _ref.version;
  return /*#__PURE__*/_react["default"].createElement(_core.AppBar, {
    position: "relative",
    className: classes.appBar
  }, /*#__PURE__*/_react["default"].createElement(_core.Toolbar, {
    className: classes.appToolBar
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    container: true,
    justify: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Link, {
    color: "inherit",
    href: "https://www.ljhooker.com.au",
    noWrap: true,
    variant: "body1",
    target: "_blank"
  }, "\xA9 ", 1900 + new Date().getYear(), " LJ Hooker")), version && /*#__PURE__*/_react["default"].createElement(_core.Grid, {
    item: true
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    color: "inherit"
  }, "v", version)))));
};

Footer.propTypes = {
  classes: _propTypes["default"].object.isRequired,
  version: _propTypes["default"].string
};

var _default = (0, _withStyles["default"])(_styles["default"])(Footer);

exports["default"] = _default;